<template>
    <base-section header="Jak se na svatbu dostanete?">

        <div class="text-xs-center">
            <p style="font-size: 0.85rem; margin-bottom: 0">Adresa</p>
            <p>Třebušín, č.p. 1, okres Litoměřice</p>
        </div>

        <text-striked class="my-3">Autem</text-striked>

        <v-layout justify-center align-center>
                <v-btn-toggle v-model="tabIndex"
                              style="flex-wrap: wrap; background: var(--v-secondary-base); box-shadow: none;">
                    <v-btn class="primary" style="text-transform: none; font-size: 0.75rem; margin: 2px;" flat
                           v-for="(route, index) in routes" :key="route.from.name" :value="index">
                        {{route.from.name}}
                    </v-btn>
                </v-btn-toggle>
        </v-layout>

        <p class="text-xs-center my-4">
            Cesta <strong v-if="activeRoute.plane">letadlem</strong> do Třebušína z města {{activeRoute.from.name}} sice trvá {{activeRoute.time}}
            a je dlouhá {{activeRoute.distance}}km, ale zpět se budete vracet až další den, po noci strávené pod nebesy zámeckých pokojů.
        </p>

        <mapy-cz :to="trebusin" :from="activeRoute.from" :hide-route="activeRoute.hideRoute"/>

        <p class="text-xs-center">
            K zámku přísluší oplocené parkoviště s dostatečnou kapacitou, takže nemusíte mít o své autíčko strach.
        </p>

        <text-striked>Vlakem / Autobusem</text-striked>
        <p class="text-xs-center">
            Pro hosty, kteří nevlastní koně pod kapotou ani mimo ní, je možnost dopravit se do Třebušína vlakem a autobusem.
            Autobus do Třebušína jezdí i v sobotu a staví přímo před zámkem.
        </p>
        <div style="font-size: 0.85rem">
            <p class="text-xs-center">(7:04) Hradec Králové >  Pardubice > Praha hl.n > Bohušovice n. Ohří > Třebušín (10:45) </p>
            <p class="text-xs-center">(8:51) Praha hl.n > Bohušovice n. Ohří > Třebušín (10:45) </p>
        </div>
        <p class="text-xs-center">
            Pokud byste měli problém s dopravou v den svatby, po domluvě můžeme také nabídnout příjezd a přenocování den předem.
        </p>

    </base-section>
</template>

<script>
    import BaseSection from "@/components/BaseSection";
    import TextStriked from "@/components/TextStriked";
    import MapyCz from "@/plugins/mapy-cz/MapyCz";

    const routes = [
        {
            from: {longtitude: 15.8327683, latitude: 50.2092283, name: "Hradec Kralové"},
            distance: 180,
            time: "1:55",
        },
        {
            from: {longtitude: 15.4602619, latitude: 50.1544031, name: "Chlumec nad Cidlinou"},
            distance: 144,
            time: "1:39"
        },
        {
            from: {longtitude: 16.7096372, latitude: 49.6294364, name: "Jevíčko"},
            distance: 282,
            time: "3:27"
        },
        {
            from: {longtitude: 16.0928944, latitude: 50.4762631, name: "Červený Kostelec"},
            distance: 220,
            time: "2:35"
        },
        {
            from: {longtitude: 15.9935283, latitude: 50.4447586, name: "Hořičky"},
            distance: 208,
            time: "2:25"
        },
        {
            from: {longtitude: 14.4341414, latitude: 50.0835494, name: "Praha"},
            distance: 76,
            time: "1:03"
        },
        {
            from: {longtitude: 17.2508706, latitude: 49.5938686, name: "Olomouc"},
            distance: 359,
            time: "3:41"
        },
        {
            from: {longtitude: 14.2967675, latitude: 50.1962011, name: "Kozinec"},
            distance: 64,
            time: "0:58"
        },
        {
            from: {longtitude: -118.485832, latitude: 34.003342, name: "Los Angeles"},
            hideRoute: true,
            distance: 9562,
            time: "13:15",
            plane: true
        }
    ];

    export default {
        name: "SectionTransport",
        components: {TextStriked, BaseSection, MapyCz},
        data() {
            return {
                tabIndex: 0,
                trebusin: {longtitude: 14.2046206, latitude: 50.5996689, name: "Trebusin"},
                routes
            }
        },
        computed: {
            activeRoute() {
                return this.routes[this.tabIndex];
            }
        },
    };
</script>